import React, { Component } from "react";
import Headers from "../Layouts/HeaderReceptionist";
import axios from "axios";
// import NextOfKin from './NextOfKin';
import { useHistory } from "react-router-dom";
import $ from "jquery";
import { config } from "../_helpers/global";
import { NewbornSidebar } from "../Layouts/NewbornSidebar";

export class NewbornDemographicData extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      name: "",
      dateofBirth: "",
      timeofBirth: "",
      age: "",
      sex: "",
      gestationalAge: "",
      birthWeight: "",
      lengthofAdmission: "",
      conditionBabyBirth: "",
      complicationaBirth: "",
      APGAR10: "",
      APGAR5: "",
      APGAR1: "",
      Baggingdone: "",
      minutesnumber: "",
      response: "",
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    this.setState({
      uniqid: (Math.random() + 1).toString(36).substring(7),
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      "Access-Control-Allow-Origin": "*",
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    let payload = {
      name: this.state.name,
      dateofBirth: this.state.dateofBirth,
      timeofBirth: this.state.timeofBirth,
      age: this.state.age,
      sex: this.state.sex,
      gestationalAge: this.state.gestationalAge,
      birthWeight: this.state.birthWeight,
      lengthofAdmission: this.state.lengthofAdmission,
      conditionBabyBirth: this.state.conditionBabyBirth,
      complicationaBirth: this.state.complicationaBirth,
      APGAR:
        "(" +
        this.state.APGAR1 +
        "," +
        this.state.APGAR5 +
        "," +
        this.state.APGAR10 +
        ")",
      Baggingdone: this.state.Baggingdone,
      minutesnumber: this.state.minutesnumber,
    };
    // console.log(payload);
    this.state.loading = true;
    axios
      .post(this.api_url+"newborn/data", payload, {
        headers: headers,
      })
      .then((response) => {
        this.state.loading = false;
        // console.log(response)
        this.setState({ response: response });
        if (response.status == 200) {
          $("#SubmitError").fadeOut("fast");
          $(".alert-success").show();
          setTimeout(function (props) {
            window.location.href = "/newbornunit/treatment/counselling";
          }, 1000);
        } else {
          $(".alert-success").fadeOut("fast");
          $("#SubmitError").show();
        }
      })
      .catch((error) => {
        this.state.loading = false;
        $(".alert-success").fadeOut("fast");
        $("#SubmitError").show();
        console.log(error);
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const {
      name,
      dateofBirth,
      timeofBirth,
      age,
      sex,
      gestationalAge,
      birthWeight,
      lengthofAdmission,
      conditionBabyBirth,
      complicationaBirth,
      APGAR1,
      APGAR10,
      APGAR5,
      Baggingdone,
      minutesnumber,
      loading,
    } = this.state;

    return (
      <div>
        {/* <NextOfKin userData = {response}/> */}
        <Headers />
        <NewbornSidebar></NewbornSidebar>

        <main className="content-container">
          <div className="container p-2">
            <div className="row pl-2 text-lg-center font-weight-bold p-1">
              <p className="text-capitalize" style={font16}>
                Newborn Demographic Data
              </p>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Baby Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={name}
                      name="name"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Date Of Birth</h6>
                    <input
                      className="form-control"
                      name="dateofBirth"
                      onChange={this.handleChange}
                      value={dateofBirth}
                      type="date"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">
                      Time Of Birth (24 Hr Format)
                    </h6>
                    <input
                      className="form-control"
                      type="time"
                      onChange={this.handleChange}
                      value={timeofBirth}
                      name="timeofBirth"
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Age</h6>
                    <input
                      className="form-control"
                      name="age"
                      onChange={this.handleChange}
                      value={age}
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Sex</h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={sex}
                      name="sex"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Gestational Age
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={gestationalAge}
                      name="gestationalAge"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Birth Weight</h6>
                    <input
                      className="form-control"
                      name="birthWeight"
                      type="text"
                      onChange={this.handleChange}
                      value={birthWeight}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Length of Admission</h6>
                    <input
                      className="form-control"
                      name="lengthofAdmission"
                      type="text"
                      onChange={this.handleChange}
                      value={lengthofAdmission}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">
                      Condition of the baby at birth:
                    </h6>
                    <textarea
                      className="form-control"
                      name="conditionBabyBirth"
                      type="text"
                      onChange={this.handleChange}
                      value={conditionBabyBirth}
                      required
                      rows="6"
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">
                      If any complication at birth specify
                    </h6>
                    <textarea
                      className="form-control"
                      name="complicationaBirth"
                      type="text"
                      onChange={this.handleChange}
                      value={complicationaBirth}
                      required
                      rows="6"
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">APGAR 1 minute</h6>
                    <input
                      className="form-control"
                      name="APGAR1"
                      type="text"
                      onChange={this.handleChange}
                      value={APGAR1}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">APGAR 5 minutes</h6>
                    <input
                      className="form-control"
                      name="APGAR5"
                      type="text"
                      onChange={this.handleChange}
                      value={APGAR5}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">APGAR 10 minutes</h6>
                    <input
                      className="form-control"
                      name="APGAR10"
                      type="text"
                      onChange={this.handleChange}
                      value={APGAR10}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Bagging Done
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Baggingdone}
                      name="Baggingdone"
                    >
                      <optgroup label="BaggingDone">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize"> How many minutes?</h6>
                    <input
                      className="form-control"
                      name="minutesnumber"
                      type="text"
                      onChange={this.handleChange}
                      value={minutesnumber}
                      required
                    />
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <br />
                <br />
                <br />
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading == false ? (
                      <span>Submit</span>
                    ) : (
                      <span>Loading</span>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default NewbornDemographicData;
